// extracted by mini-css-extract-plugin
module.exports = {"menu_container":"MenuSide_menu_container__2s53I","MenuSide_show":"MenuSide_MenuSide_show__1XqEd","MenuSide_hidden":"MenuSide_MenuSide_hidden__117Sv"};